import React from 'react'

export const ArrowRightUp = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6105)'>
      <path
        d='M13.05 12.3601L7.394 18.0181L5.98 16.6031L11.637 10.9471L6.687 5.99707H18V17.3101L13.05 12.3601Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6105'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
